
import { utils } from 'src/utils';
import { useAuthStore } from 'src/stores/auth';

const publicPages = ['/', '/index', '/error']; //public pages which do not need authentation
const excludedRoutes = []; //public pages which do not need authentation
const roleAbilities = {
  "admin": [],
  "user": [],
  "humanizacao": []
};

export function useAuth() {
	const store = useAuthStore();
	const state = store.state;
	const user = state.user;
	
	let isLoggedIn = false;
	let userName = '';
	let userEmail = '';
	let userId = '';
	let userPhoto = '';
	let userPhone = '';
	let userRole = '';

	setUserData();

	function setUserData(){
		if(user){
			isLoggedIn = true;
			userName = user.name;
			userId = user.id;
			userRole = state.userRoles.toString();
			userEmail = user.email;
			userPhoto = user.image;
			userPhone = user.phone;
		}
	}

	async function getUserData(){
		const token = store.getLoginToken();
		if (token) {	//Token is available, user might still be logged in
			try {
				//fetch user data for the first time and saves in the store
				await store.getUserData();
				return store.state.user;
			}
			catch (e) {
				store.logout(); //token must have expired
			}
		}

		return null;
	}

	function login(payload) {
		return store.login(payload);
	}

	function saveLoginData(loginData, rememberUser) {
		const payload =  { loginData, rememberUser };
		store.saveLoginData(payload);
	}
	
	function logout() {
		store.logout();
	}

	const pageRequiredAuth = function(path){
		let pagePath = utils.getPagePath(path);
		let routePath = utils.getRoutePath(path);
		let authRequired = true;
		if(publicPages.includes(pagePath) || excludedRoutes.includes(routePath)){
			authRequired = false;
		}
		return authRequired
	}

	const canView = function(path){
		if(path){
			let routePath = utils.getRoutePath(path);
			const userPages = state.userPages;
			return userPages.includes(routePath) || excludedRoutes.includes(routePath);
		}
		return true;
	}

	const canManage = function(page, userRecId){
		if(userRole){
			let userRoleAbilities = roleAbilities[userRole.toLowerCase()] || [];
			if (userRoleAbilities.includes(page)){
				return true;
			}
		}
		return userRecId == userId;
	}

	function isOwner(userRecId) {
		if(user){
			return userRecId == userId;
		}
		return false;
	}

	
	const isAdmin = userRole.toLowerCase() == 'admin';

	const isUser = userRole.toLowerCase() == 'user';

	const isHumanizacao = userRole.toLowerCase() == 'humanizacao';


	return {
		isLoggedIn,
		user,
		userName,
		userId,
		userEmail,
		userPhone,
		userPhoto,
		userRole,
		getUserData,
		login,
		logout,
		saveLoginData,
		pageRequiredAuth,
		canView,
		canManage,
		isOwner,
		isAdmin, isUser, isHumanizacao
	}
}
